import { Navigate, useLocation } from 'react-router-dom';

import { useAppDispatch } from '@/configuration/setup/hooks';
import { IS_IFRAME_ROUTE, resolveNavigation } from '@/routes/handleLayoutRedirect';
import { setCurrentLayout } from '@/store/layout/layoutSlice';

import { INavigationResolverProps } from './types';


/* INFO: Extracted the navigation decisions from AppLayout to avoid conditional early returns that break hook ordering
in the parent component
*/ 

const NavigationResolver = ({ section, subsection, children }: INavigationResolverProps) => {
    const dispatch = useAppDispatch();
    const { pathname } = useLocation();

    const isIframeTestRoute = pathname === IS_IFRAME_ROUTE;

    const decision = resolveNavigation(section, subsection, isIframeTestRoute);

    switch (decision.type) {
        case 'redirect':
            return <Navigate to={decision.to} replace state={decision.state} />;

        case 'fallback':
            dispatch(setCurrentLayout('chat'));
            return <Navigate to="chat" replace />;

        case 'set-layout':
            dispatch(setCurrentLayout(decision.layout));
            return <>{children}</>;

        default:
            return <>{children}</>;
    }
};

export default NavigationResolver;